import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { Textarea, Label, Arrow } from 'rebass';
import { Box } from 'reflexbox';

class SimcLog extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    lines: PropTypes.number,
    log: PropTypes.string,
    alwaysShow: PropTypes.bool,
    open: PropTypes.bool,
    onToggle: PropTypes.func,
  };

  static defaultProps = {
    title: 'SimulationCraft Log',
    lines: 10,
    log: '',
    alwaysShow: false,
    open: true,
    onToggle: null,
  };

  componentDidMount() {
    if (this.props.log && this.props.open) {
      this.node.scrollTop = this.node.scrollHeight;
    }
  }

  componentDidUpdate() {
    if (this.props.log && this.props.open) {
      this.node.scrollTop = this.node.scrollHeight;
    }
  }

  render() {
    const { title, lines, log, alwaysShow, open, onToggle } = this.props;

    if (!alwaysShow && !log) {
      return null;
    }

    return (
      <Box m={0}>
        <Label onClick={onToggle}>
          {title}
          {
            onToggle !== null &&
            <Arrow direction={open ? 'down' : 'up'} />
          }
        </Label>
        {open ? (
          <Textarea
            m={0}
            p={0}
            baseRef={(textarea) => { this.node = textarea; }}
            name="log"
            label=""
            value={_.trimEnd(log)}
            rows={lines}
            backgroundColor="rgba(255,255,255,.45)"
            style={{
              fontFamily: 'monospace',
            }}
            readOnly
          />
        ) : null}
      </Box>
    );
  }
}

export default SimcLog;
